import { ISupplier } from "@app/modules/messages/models/ISupplier";
import { Message } from "@progress/kendo-angular-conversational-ui";

export enum ActionTypes {
  Reply = "reply",
  Prompt = "prompt",
  MoreHelp = "more",
  NoMoreHelp = "noMore",
  IDontKnow = "iDontKnow",
}

export interface ChatBotMessage extends Message {
  conversationId?: string;
  systemMessageId?: string;
  userMessageId?: string;
  allowFeedback?: boolean;
  links?: Link[];
}

export interface ConnectUser {
  Name: string;
  FirstName: string;
  LastName: string;
  Email: string;
  IsInternalUser: boolean;
  IsConnectChatbotAuthorized: boolean;
  SupplierList?: ISupplier[];
}

export interface Messages {
  RequestMessage: string;
  ResponseMessage: string;
  ResponseLinkObjects: ResponseLinkObjects[];
}

export interface ResponseLinkObjects {
  url: string;
  title: string;
  isExternal: boolean;
}

export interface ChatBotSendMessageRequest {
  RequestUser: ConnectUser;
  RequestMessage: string;
  RequestMessagePrompt?: string;
}

export interface ChatBotSendMessageResponse {
  RequestUser: ConnectUser;
  Messages: Messages;
  conversationId: string;
  systemMessageId: string;
  userMessageId: string;
}

export interface ChatBotSendFeedbackRequest {
  conversationId: string;
  systemMessageId: string;
  userMessageId: string;
  requestMessage: string;
  responseFeedback: boolean;
  responseFeedbackReason?: string;
  responseFeedbackInputText?: string;
}

export interface Prompt {
  text: string;
  children: Prompt[];
}

export interface FeedbackFormValue {
  reason: string;
  comments?: string;
}

export interface Link {
  url: string;
  title: string;
  isExternal: boolean;
}
